import { applicationService } from '@/projects/admin/services/application-service';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import CustomStore from 'devextreme/data/custom_store';
import { DataGrid } from 'devextreme-react/data-grid';
import { ROUTER_CONSTANTS } from '@/core/constants/common/router-constants';

const ApplicationFeatureList = () => {
    const [store, setStore] = useState<CustomStore>();
    const dataGridRef = useRef<DataGrid>(null);
    useEffect(() => {
        setStore(new CustomStore({
            key: ['id'],
            load: applicationService.getApplicationFeatures,
            byKey: async (key, loadOptions: any) => {
                let returnObject = null;
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                    const objectsByID = (await applicationService.getApplicationFeatures(loadOptions))
                    returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                }
                return returnObject
            },
            remove: applicationService.deleteApplicationFeature,
            useDefaultSearch: true
        }));
    }, [])


    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/admin/${ROUTER_CONSTANTS.ADMIN.ApplicationFeatures}/${id}`, { state: { id: id } })
    }

    return (
        <div>
            <DataGridWrapper
                permissonCode='Admin.Application.Feature'
                datasource={store}
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath={'/admin/'+ ROUTER_CONSTANTS.ADMIN.ApplicationFeatureCreate}
                props={{ id: 'application-feature-list', ref: dataGridRef }}
                editingConfig={{
                    allowDeleting: true,
                    allowUpdating: true,
                    deleteMessageText: RemoveMessage(t('feature')),
                }}
                columns={[
                    { dataField: 'name', caption: t('feature'), allowFiltering: true },
                    { dataField: 'featureType', caption: t('feature_type'), allowFiltering: true },
                    { dataField: 'applicationModule', caption: t('module'), allowFiltering: true },
                    { dataField: 'application', caption: t('application'), allowFiltering: true },
                    { dataField: 'path', caption: t('path'), allowFiltering: true },
                    {
                        dataField: 'order', caption: t('order'), sortOrder: "desc",
                        sortIndex: 0, visible: false
                    },
                    { dataField: 'permissionDependencyCount', caption: t('permissions'), allowFiltering: true, width: 200 }
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: function (e: any) {
                            goToEdit(e.row?.data.id);
                        },
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </div>
    )
}
export default ApplicationFeatureList